import React from "react";
import { Form, Button, Image, Modal } from "react-bootstrap";
import { Field } from "../../component";
import IconPin from "../../assets/icon-pin.png";
import { DisplayAttachments } from "../reusableComponent/displayAttachments";
import { UploadAttachmentsWithTitleComponent } from "../reusableComponent/uploadAttchements";
import { DOCUMENT_FORMATS } from "../../constant";
import { get } from "lodash";
import { toast } from "react-toastify";
import { errorToastStyle } from "../../customToast";

const ModalVerifyIIGProject = props => {
  const {
    show,
    onHide,
    comment,
    onCommentChange,
    onVerify,
    error,
    createdDate
  } = props;

  const [showAttachmentDisplay, setShowAttachmentDisplay] = React.useState(
    false
  );
  const [attachmentFiles, setAttachmentFiles] = React.useState([]);
  const [attachmentFileIds, setAttachmentFileIds] = React.useState([]);
  const targetDate = createdDate;
  const dateAfterCrip = new Date("2026-07-08").getTime();

  React.useEffect(() => {
    setAttachmentFileIds(attachmentFiles.map(file => file.id));
  }, [attachmentFiles]);

  const onSuccessUploadOfAttachment = async data => {
    try {
      setAttachmentFiles([...attachmentFiles, data]);
    } catch (error) {
      toast.error(
        <p className="toast-text-alignment">{error.message}</p>,
        errorToastStyle
      );
    }
  };
  const onBlur = value => {};
  const onRemoveAttachment = ({ id }) => {
    try {
      setAttachmentFiles(attachmentFiles.filter(val => val.id !== id));
    } catch (error) {
      toast.error(
        <p className="toast-text-alignment">
          Error while deleting the image {error.message}
        </p>,
        errorToastStyle
      );
    }
  };

  const toggleAttachmentDisplay = () => {
    setShowAttachmentDisplay(!showAttachmentDisplay);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form className="iig-modal-for-verified-action">
        <div class="iig-modal-body">
          <Modal.Header closeButton />
          <Modal.Body className="pt-4 pb-2">
            <div class="row">
              <h4 class="page-heading iig-modal-heading ml-3">
                Verify {targetDate >= dateAfterCrip ? "CRIP" : "IIG"} Draft
              </h4>
            </div>
            <p class="page-subline iig-modal-heading-content">
              Taking this action will change the status from{" "}
              {targetDate >= dateAfterCrip ? `'CRIP Draft'` : `'IIG Draft'`} to
              'Verified'
            </p>
            <Form.Group className="text-area iig-modal-heading mb-0">
              <Field
                as="textarea"
                rows="5"
                placeholder="Comment"
                key="comment"
                keyName="comment"
                value={comment}
                onChange={onCommentChange}
                isInvalid={get(error, "comment.error")}
                onBlur={onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {get(error, "comment.message")}
              </Form.Control.Feedback>
            </Form.Group>
            <div class="row iig-add-attachment pb-0">
              <div>
                <Form.Group className="field-attachment mt-3">
                  {showAttachmentDisplay && (
                    <UploadAttachmentsWithTitleComponent
                      displayModal={showAttachmentDisplay}
                      onCloseModal={toggleAttachmentDisplay}
                      fileFormats={DOCUMENT_FORMATS}
                      onSubmit={onSuccessUploadOfAttachment}
                    />
                  )}
                  <DisplayAttachments
                    filesArr={attachmentFiles}
                    onRemoveFile={onRemoveAttachment}
                    addAttchementRequired={false}
                    classes="attachments"
                  />
                </Form.Group>
                <div
                  className="add-attachment"
                  onClick={toggleAttachmentDisplay}
                >
                  <div className="add-attachment-button">
                    <Image
                      src={IconPin}
                      alt="Attachment Icon"
                      className="add-attachment-img"
                    />
                    <span className="add-attachment-text">Add Attachment</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <div class="iig-modal-footer">
            <Modal.Footer className="border-0 pt-0 pl-3">
              <div class="col">
                <div class="row iig-context-button-content justify-content-between align-items-center">
                  <div className="page-subline">
                    <span className="iig-modal-content">
                      Do you want to take this action?
                    </span>
                  </div>
                  <div class="iig-modal-buttons d-flex">
                    <div class="iig-no-button">
                      <Button
                        className="btn-orange-invert no-padding px-5"
                        onClick={onHide}
                      >
                        No
                      </Button>
                    </div>
                    <div>
                      <Button
                        className="btn-orange no-padding px-5"
                        onClick={() => onVerify(attachmentFileIds)}
                      >
                        Yes
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalVerifyIIGProject;
